import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes";

const EnvelopeOutlineIcon = ({ height = "16", width = "16", fill = theme.colors["blue-ribbon"] }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        d="M1.33334 4.66675L6.77662 8.47704C7.2174 8.78559 7.43779 8.93986 7.67752 8.99962C7.88927 9.0524 8.11075 9.0524 8.3225 8.99962C8.56223 8.93986 8.78262 8.78559 9.2234 8.47704L14.6667 4.66675M4.53334 13.3334H11.4667C12.5868 13.3334 13.1468 13.3334 13.5747 13.1154C13.951 12.9237 14.2569 12.6177 14.4487 12.2414C14.6667 11.8136 14.6667 11.2535 14.6667 10.1334V5.86675C14.6667 4.74664 14.6667 4.18659 14.4487 3.75877C14.2569 3.38244 13.951 3.07648 13.5747 2.88473C13.1468 2.66675 12.5868 2.66675 11.4667 2.66675H4.53334C3.41324 2.66675 2.85319 2.66675 2.42536 2.88473C2.04904 3.07648 1.74308 3.38244 1.55133 3.75877C1.33334 4.18659 1.33334 4.74664 1.33334 5.86675V10.1334C1.33334 11.2535 1.33334 11.8136 1.55133 12.2414C1.74308 12.6177 2.04904 12.9237 2.42536 13.1154C2.85319 13.3334 3.41324 13.3334 4.53334 13.3334Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default EnvelopeOutlineIcon;
